module.exports = "../dist/img/mini-19.2186.jpg";